<div class="page-wrapper members-page" #containerMembers>
  <div class="wrap-breadcrumb">
    <div class="container">
      <div class="breadcrumb">
        <div>
          <a style="margin-right: 2px;" routerLink="/">Accueil</a> > Adhérents
        </div>
      </div>
    </div>
  </div>
  <div class="members-page-inner">
    <div class="container">
      <h2 class="title d-flex align-items-center gap-2">LES ADHÉRENTS</h2>
      <div class="filter-export d-flex justify-content-between align-items-center">
        <form [formGroup]="formFilter" class="">
          <div class="wrap-form d-flex justify-content-between align-items-center">
            <div class="wrap-input">
              <label for="">Code adhérent</label>
              <input formControlName="code" type="text" placeholder="Rechercher par code adhérent" />
            </div>
            <div class="wrap-input">
              <label for="">Raison sociale</label>
              <input (focusout)="emptyList()" (keyup)="onSearchInput()" formControlName="companyName" type="text"
                placeholder="Rechercher un adhérent" />
              <div class="autocomplete-list" *ngIf="autocompleteSearchlistMembers.length > 0">
                <ul class="p-0" style="list-style: none">
                  <li class="ac-li" *ngFor="let item of autocompleteSearchlistMembers" (click)="selectItem(item)">
                    {{item.companyName}}
                  </li>
                </ul>
              </div>
            </div>
            <div class="wrap-input">
              <label for="">Code postal</label>
              <input formControlName="postcode" type="text" placeholder="Rechercher par code postal" />
            </div>
            <button (click)="filterCompany()" class="btn-search">
              <img src="src-adisco/assets/images/icon/Icon open-magnifying-glass.svg" alt="">
            </button>
          </div>
        </form>
        <button *ngIf="userService.hasExtranetAccess('fonctions', 'export-adhérents')" class="btn-common btn-export"
          (click)="onExport()">EXPORTER</button>
      </div>
      <div class="wrap-pagi">
        <form [formGroup]="formPagination" class="">
          <div *ngIf="totalPages > 0" class="wrap-pagination">
            <div class="d-flex justify-content-between align-items-center mb-3">
              <div class="wrap-rows">
                Afficher
                <p-dropdown formControlName="rows" (onChange)="filterRows()" class="item-page" [options]="listRows"
                  optionLabel=""></p-dropdown>éléments
              </div>
              <p-paginator *ngIf="totalPages > 1" #paginator1 [ngClass]="{'show-dot': totalPages > 5 }"
                (onPageChange)="onPageChange($event)" [rows]="rows3" [totalRecords]="totalRecords"
                [showFirstLastIcon]="false" [showCurrentPageReport]="false"></p-paginator>
            </div>
          </div>
        </form>
      </div>
      <div class="list-members d-flex">
        <div *ngFor="let member of listMembers" class="member">
          <div class="wrap-general-info d-flex">
            <div class="wrap-img">
              <img *ngIf="member?.logo" class=""
                src="{{ member?.logo[0]?.url ? member?.logo[0]?.url : 'src-adisco/assets/images/image-default.jpeg' }}"
                alt="" />
              <img *ngIf="!member?.logo" class="" src="src-adisco/assets/images/image-default.jpeg" alt="" />
            </div>
            <div class="general-info">
              <p class="name mb-0">{{ member?.companyName }}</p>
              <p class="mb-0">
                Téléphone : <span>{{ member.phone ? member.phone : '-'}}</span>
              </p>
              <p class="mb-0">
                Fax : <span>{{ member.fax ? member.fax : '-'}}</span>
              </p>
              <p class="mb-0">
                Email : <span>{{ member.email ? member.email : '-' }}</span>
              </p>
              <p class="mb-2">
                Ville : <span *ngIf="member?.postcode">{{ member?.postcode }}, </span>
                <span *ngIf="member?.city">{{ member?.city }} </span>
              </p>
              <button routerLink="/members/detail-member/{{ member?.code }}" class="btn-common">VOIR LA FICHE</button>
            </div>
          </div>
        </div>
        <div class="loading" *ngIf="loadingStatus">
          <img src="/src-adisco/assets/images/icon/loading.gif" alt="">
        </div>
      </div>
      <div class="wrap-pagi">
        <form [formGroup]="formPagination" class="">
          <div *ngIf="totalPages > 0" class="wrap-pagination">
            <div class="d-flex justify-content-between align-items-center mb-3">
              <div class="wrap-rows">
                Afficher
                <p-dropdown formControlName="rows" (onChange)="filterRows()" class="item-page" [options]="listRows"
                  optionLabel=""></p-dropdown>éléments
              </div>
              <p-paginator *ngIf="totalPages > 1" #paginator2 [ngClass]="{'show-dot': totalPages > 5 }"
                (onPageChange)="onPageChange($event)" [rows]="rows3" [totalRecords]="totalRecords"
                [showFirstLastIcon]="false" [showCurrentPageReport]="false"></p-paginator>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
